var _path, _path2, _path3, _path4, _rect, _rect2, _rect3, _rect4, _rect5, _polygon, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcons8WritingDown50(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 48 48",
    width: "50px",
    height: "50px",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#455a64",
    d: "M36,4H26c0,1.105-0.895,2-2,2s-2-0.895-2-2H12C9.789,4,8,5.789,8,8v32c0,2.211,1.789,4,4,4h24 c2.211,0,4-1.789,4-4V8C40,5.789,38.211,4,36,4"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M36,41H12c-0.551,0-1-0.449-1-1V8c0-0.551,0.449-1,1-1h24c0.551,0,1,0.449,1,1v32 C37,40.551,36.551,41,36,41"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#90a4ae",
    d: "M26,4c0,1.105-0.895,2-2,2s-2-0.895-2-2h-7v4c0,1.105,0.895,2,2,2h14c1.105,0,2-0.895,2-2V4H26z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#90a4ae",
    d: "M24,0c-2.207,0-4,1.793-4,4s1.793,4,4,4s4-1.793,4-4S26.207,0,24,0 M24,6c-1.105,0-2-0.895-2-2 s0.895-2,2-2s2,0.895,2,2S25.105,6,24,6"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 2,
    x: 15,
    y: 23,
    fill: "#bdbdbd"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 2,
    x: 15,
    y: 19,
    fill: "#bdbdbd"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 2,
    x: 15,
    y: 15,
    fill: "#bdbdbd"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    width: 17,
    height: 2,
    x: 15,
    y: 27,
    fill: "#bdbdbd"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 2,
    x: 15,
    y: 31,
    fill: "#bdbdbd"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    fill: "#bdbdbd",
    points: "15,35 27,35 24,37 15,37"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#ffb74d",
    d: "M48,25.54V37h-6l-0.25-5.75H33.5V24.5l-5.92,6.05c-0.37,0.4-0.89,0.6-1.4,0.6 c-0.45-0.01-0.89-0.18-1.25-0.51c-0.75-0.71-0.8-1.89-0.09-2.65l7.27-7.39C32.49,20.22,33,20,33.54,20H41c0.55,0,1.1,0,1.46,0.18 L48,25.54z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#e69329",
    d: "M37.827,25.848l-0.003-0.003l-3.732,4.267l3.634,0.396l4.023-2.258l-1.5-2.992l-1.327-0.671 l-0.113,0.126l-0.491,0.568l0,0l-0.021,0.024L37.827,25.848z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "#e57373",
    d: "M45.678,18.142l-2.82-2.819c-0.429-0.43-1.126-0.43-1.555,0l-1.328,1.327L41,20l3.351,1.025 l1.327-1.328C46.107,19.268,46.107,18.572,45.678,18.142"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fill: "#b0bec5",
    d: "M44.352,21.025l-2.187,2.188L39,22l-1.212-3.162l2.187-2.188L44.352,21.025z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fill: "#00acc1",
    d: "M25.472,31.147l12.315-12.315l4.376,4.376L29.848,35.522L27,34L25.472,31.147z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fill: "#ffc107",
    d: "M25.473,31.152l-0.728,2.892L25,36l1.956,0.256l2.892-0.728L25.473,31.152z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fill: "#ffb74d",
    d: "M28.35,31.073L28.35,31.073c-0.396,1.246,0.44,2.329,1.52,2.744l8.007,2.291 c0.54,0.209,3.151,1.398,5.029,0.665c2.096-0.818,3.9-2.539,3.9-2.539l-5.056-6.242l-4.023,2.258l-6.102-0.664 C29.904,29.301,28.774,29.81,28.35,31.073"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fill: "#ffe0b2",
    d: "M29.8,32.836c-0.683-0.307-0.988-1.11-0.681-1.794c0.308-0.683,1.111-0.989,1.795-0.68 C31.597,30.668,30.484,33.143,29.8,32.836"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    fill: "#37474f",
    d: "M24.744,34.044L24,37l2.956-0.744L24.744,34.044z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcons8WritingDown50);
export default __webpack_public_path__ + "static/media/icons8-writing-down-50.16488d0b4d1978927c9447db8f29a3c0.svg";
export { ForwardRef as ReactComponent };